module.exports = __webpack_public_path__ + "static/media/606346899_mobile.dc4f71ac.jpg";